import React from 'react';
import { AddInStorage } from '../storage/AddInStorage';
import { getIsLocalDevelopment } from '../util-helpers/common';

/**
 * A simple component to test authentication by setting invalid token values
 */
const AuthTester: React.FC = () => {
  // Only show in development mode
  if (!getIsLocalDevelopment()) {
    return null;
  }

  const invalidateAccessToken = () => {
    console.log('Setting invalid access token');
    AddInStorage.setItem('access_token', 'invalid-access-token-value');
    console.log('Storage after setting invalid access token:', {
      access_token: AddInStorage.getItem('access_token'),
      refresh_token: AddInStorage.getItem('refresh_token'),
      id_token: AddInStorage.getItem('id_token')
    });
  };

  const invalidateRefreshToken = () => {
    console.log('Setting invalid refresh token');
    AddInStorage.setItem('refresh_token', 'invalid-refresh-token-value');
    console.log('Storage after setting invalid refresh token:', {
      access_token: AddInStorage.getItem('access_token'),
      refresh_token: AddInStorage.getItem('refresh_token'),
      id_token: AddInStorage.getItem('id_token')
    });
  };

  // For direct console testing
  (window as any).testAuth = {
    invalidateAccessToken,
    invalidateRefreshToken,
    checkStorage: () => {
      console.log('Current storage state:', {
        access_token: AddInStorage.getItem('access_token'),
        refresh_token: AddInStorage.getItem('refresh_token'),
        id_token: AddInStorage.getItem('id_token'),
        lastEnvironment: localStorage.getItem('lastEnvironment')
      });
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 999, // Lower z-index to ensure Snackbar appears above
      padding: '15px',
      paddingTop: '5px',
      border: '1px solid #ccc',
      borderRadius: '5px',
      backgroundColor: 'white',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
      maxWidth: '250px'
    }}>
      <h3 style={{ marginTop: '5px', fontSize: '16px' }}>Auth Testing</h3>
      <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
        <button
          type="button"
          onClick={invalidateAccessToken}
          style={{ padding: '6px 12px', cursor: 'pointer', fontSize: '14px' }}
        >
          Invalidate Access Token
        </button>
        <button
          type="button"
          onClick={invalidateRefreshToken}
          style={{ padding: '6px 12px', cursor: 'pointer', fontSize: '14px' }}
        >
          Invalidate Refresh Token
        </button>
      </div>
    </div>
  );
};

export default AuthTester;
